import axios from './axios';

export const getUserById = id => axios.get(`/users/${id}`);

export const searchUsers = query => axios.post('/users', query);

export const deactivateUserRole = id => axios.put(`/users/${id}/deactivate`);

export const activateUserRole = id => axios.put(`/users/${id}/activate`);

export const deleteUserById = id => axios.delete(`/systemusers/${id}`);

export const createSystemUser = formdata => axios.post(`/systemusers`, formdata);

export const getSystemUser = userId => axios.get(`/systemusers/${userId}`);

export const updateSystemUser = (userId, formdata) => axios.put(`/systemusers/${userId}`, formdata);
